export default __webpack_public_path__ + "static/media/R100.5011bf2e.png";